<template>
    <v-navigation-drawer
            app
            v-model="drawer"
            :color="color"
            :expand-on-hover="expandOnHover"
            :mini-variant="miniVariant"
            dark
            permanent
    >
        <v-list
                dense
                nav
                class="py-0"
        >
            <v-list-item two-line >
                <v-list-item-avatar>
                    <img src="" alt="Tigris Wholesale Logo">
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title>Tigris Manager</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item
                    v-for="item in items"
                    :key="item.title"
                    :to="{ name: item.routeName}"
            >
                <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title >{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
  export default {
    name: "Menu",
    data () {
      return {
        drawer: true,
        items: [
          { title: 'Orders', routeName: "orders-list", icon: 'mdi-view-dashboard' },
          { title: 'Items', routeName: "items-list", icon: 'mdi-image' },
          { title: 'Warehouses', routeName: "warehouses-list"},
          { title: 'Preorders (Incoming stock)', routeName: "incoming-stock"},
        ],
        color: 'primary',
        right: true,
        miniVariant: false,
        expandOnHover: false,
        background: false,
      }
    },
  }
</script>

<style scoped>
a {

}
</style>